import { render, staticRenderFns } from "./AppTitle.vue?vue&type=template&id=8a7aea0c&scoped=true"
import script from "./AppTitle.vue?vue&type=script&lang=js"
export * from "./AppTitle.vue?vue&type=script&lang=js"
import style0 from "./AppTitle.vue?vue&type=style&index=0&id=8a7aea0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7aea0c",
  null
  
)

export default component.exports